import { isDOM } from '@app/shared/predicates'

import { createApp } from '@app/adapters/create-app'

import SearchFilter from '@app/application/sf-assistant-checks/components/search-filter.vue'

window.onDomLoad(function ($doc) {
  const doc = $doc[0]

  if (!isDOM(doc)) {
    return
  }

  const banner = document.querySelector(
    '[data-behaviour="sf-assistant-checks-filters"]'
  )

  if (banner) {
    createApp(
      SearchFilter,
      { initialSearch: $(banner).data('search') },
      {
        singletonId: 'sf-assistant-checks-filters',
      }
    ).mount(banner)
  }
})
